
import { Component, Vue } from 'vue-property-decorator';
import SectionTitle from '@/components/SectionTitle.vue';

@Component({
  name: 'SectionAbout',
  components: { SectionTitle }
})
export default class SectionAboutComponent extends Vue {}
